import React from "react";

import styles from "./leftnav.css";

export function LeftNav() {
  return <div id="leftnavcontainer" className={`${styles.leftNavWrapper}`} />;
}
